if (!customElements.get('ats-bianchi-color-selector')) {
  customElements.define(
    'ats-bianchi-color-selector',
    class AtsBianchiColorSelector extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (!this.dataset.productTags.includes('colori-ats-bianchi')) return;

        this.productId = this.dataset.productId;
        this.storageKey = `ats-bianchi-color-selection-${this.productId}`;
        this.colorTableUrl = this.dataset.colorTableUrl;
        this.colorData = null;

        // UI Elements
        this.inputGroup = this.querySelector('.ats-bianchi-input-group');
        this.colorInputDisplay = this.querySelector('.ats-bianchi-color-display');
        this.colorInputReal = this.querySelector('.ats-bianchi-color-real');
        this.selectedPreview = this.querySelector('.ats-bianchi-selected-preview');
        this.toggleBtn = this.querySelector('.ats-bianchi-toggle-btn');
        this.clearBtn = this.querySelector('.ats-bianchi-clear-btn');
        
        // Modal Elements
        this.modalOverlay = this.querySelector('.ats-bianchi-modal-overlay');
        this.modalCloseBtn = this.querySelector('.ats-bianchi-modal-close');
        this.colorsContainer = this.querySelector('.ats-bianchi-colors-container');

        this.initialize();
      }

      async initialize() {
        this.setupEventListeners();
        
        try {
          await this.fetchColorData();
          this.renderColors();
          this.restoreSelection();
        } catch (error) {
          console.error('ATS Bianchi Color Selector: Init failed', error);
          this.toggleBtn.textContent = 'Errore caricamento dati';
        }
      }

      async fetchColorData() {
        if (this.colorData) return;
        const response = await fetch(this.colorTableUrl);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        this.colorData = await response.json();
      }

      setupEventListeners() {
        this.toggleBtn.addEventListener('click', () => this.openModal());
        this.modalCloseBtn.addEventListener('click', () => this.closeModal());
        this.modalOverlay.addEventListener('click', (e) => {
          if (e.target === this.modalOverlay) this.closeModal();
        });

        this.clearBtn.addEventListener('click', () => this.clearSelection());

        this.colorsContainer.addEventListener('click', (e) => {
          const swatch = e.target.closest('.ats-bianchi-color-swatch');
          if (swatch) {
            this.selectColor(swatch.dataset.code);
            this.closeModal();
          }
        });
      }

      renderColors() {
        if (!this.colorData) return;

        // Raggruppa per tonalità
        const grouped = this.colorData.reduce((acc, color) => {
          const key = color.tonalita || 'ALTRO';
          if (!acc[key]) acc[key] = [];
          acc[key].push(color);
          return acc;
        }, {});

        this.colorsContainer.innerHTML = '';

        // Ordine personalizzato tonalità se necessario, altrimenti alfabetico
        const sortedKeys = Object.keys(grouped).sort();

        sortedKeys.forEach(tonalita => {
          const section = document.createElement('div');
          section.className = 'ats-bianchi-tonalita-section';
          
          const title = document.createElement('div');
          title.className = 'ats-bianchi-tonalita-title';
          title.textContent = tonalita;
          section.appendChild(title);

          const grid = document.createElement('div');
          grid.className = 'ats-bianchi-color-grid';

          grouped[tonalita].forEach(color => {
            const swatch = document.createElement('div');
            swatch.className = 'ats-bianchi-color-swatch';
            swatch.dataset.code = color.code;
            swatch.title = `${color.code}`;
            swatch.style.backgroundColor = `rgb(${color.r}, ${color.g}, ${color.b})`;

            const codeLabel = document.createElement('div');
            codeLabel.className = 'ats-bianchi-swatch-code';
            codeLabel.textContent = color.code;
            
            swatch.appendChild(codeLabel);
            grid.appendChild(swatch);
          });

          section.appendChild(grid);
          this.colorsContainer.appendChild(section);
        });
      }

      selectColor(code) {
        const color = this.colorData.find(c => c.code === code);
        if (!color) return;

        this.colorInputReal.value = code;
        this.colorInputDisplay.value = code;
        this.selectedPreview.style.backgroundColor = `rgb(${color.r}, ${color.g}, ${color.b})`;
        this.inputGroup.classList.add('has-selection');
        
        sessionStorage.setItem(this.storageKey, code);
      }

      clearSelection() {
        this.colorInputReal.value = '';
        this.colorInputDisplay.value = '';
        
        this.inputGroup.classList.remove('has-selection');
        sessionStorage.removeItem(this.storageKey);
      }

      restoreSelection() {
        const saved = sessionStorage.getItem(this.storageKey);
        if (saved) this.selectColor(saved);
      }

      openModal() {
        this.modalOverlay.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }

      closeModal() {
        this.modalOverlay.classList.remove('is-visible');
        document.body.style.overflow = '';
      }
    }
  );
}
